import Vue from 'vue'
import { savePref, getPref } from 'oderon-vue/Prefs'

export default new Vue({
  data() {
    return {
      prefsKey: 'oderonAdminBoltBookmars',
      items: []
    }
  },
  created() {
    // this.items = await ...
    let str = getPref(this.prefsKey)
    if (str != null) {
      this.items = JSON.parse(str)
    }
  },
  methods: {
    addBookmark(label, to) {
      this.items.push({ label, to, icon: 'mdi-book-outline' })
      savePref(this.prefsKey, JSON.stringify(this.items))
    },
    removeBookmark(to) {
      this.items = this.items.filter((x) => x.to != to)
      savePref(this.prefsKey, JSON.stringify(this.items))
    }
  }
})
